export default async function getQualityControlMenu() {
  return [
    {
      key: 'deficiencys',
      icon: 'fe fe-package',
      url: '/deficiencylist',
      permission: 'quality_view',
    },
    {
      key: 'qualityControls',
      icon: 'fe fe-package',
      url: '/qualityControl',
      permission: 'quality_view',
    },
  ]
}
